'use client';

import type {
  SelectButtonContainerProps,
  SelectButtonOptionProps,
} from '@hc-frontend/core-ui';
import { AutoSubmitRadioButton } from '@hc-frontend/core-ui';
import { addClassName } from '@hc-frontend/core-utils-format';

export function GenericSurveyOption({
  label,
  value,
  onChange,
  onClick,
  inputId,
  disabled,
  // Using default value as "true" for backward compatibility
  required = true,
  name,
  type,
  inputProps,
}: SelectButtonOptionProps) {
  return (
    <label
      className="hc-cluster-layout group relative w-full cursor-pointer flex-nowrap gap-16-16 rounded-lg border border-primary-900 p-16-16 outline-offset-2 outline-tertiary-900 transition-all hover:border-secondary-variant-900 active:scale-[0.98] has-[:disabled]:pointer-events-none has-[:checked]:border-secondary-variant-900 has-[:checked]:bg-secondary-variant-50 has-[:focus]:outline"
      htmlFor={`${inputId}-${value}`}
    >
      <AutoSubmitRadioButton
        {...inputProps}
        id={`${inputId}-${value}`}
        className="peer absolute opacity-0"
        onChange={onChange}
        onClick={onClick}
        name={name}
        value={value}
        disabled={disabled}
        required={required}
        type={type}
      />
      <span
        className={addClassName(
          "hidden size-[20px] min-w-[20px] items-center justify-center border-2 border-primary-900 transition-all after:block after:size-[12px] after:bg-gray-50 after:transition-all after:content-[''] group-hover:border-secondary-variant-900 after:group-hover:bg-secondary-variant-50 peer-checked:border-secondary-variant-900 after:peer-checked:bg-secondary-900 tablet:flex",
          type === 'checkbox'
            ? 'rounded-md after:rounded-sm'
            : 'rounded-full after:rounded-full',
        )}
        aria-hidden="true"
      />
      <span className="hc-typography--paragraph-lg font-semibold text-primary-900">
        {label}
      </span>
    </label>
  );
}

export function GenericSurveyOptionsContainer({
  children,
  errorText,
}: SelectButtonContainerProps) {
  return (
    <div className="flex w-full flex-col gap-8-8">
      {children}
      <span className="hc-error-text">{errorText}</span>
    </div>
  );
}
